import { useEffect, useRef, useState } from "react"
import { Formik, Field, Form } from "formik"
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    Wrapper,
    CombineInputGroup,
    ActionSection,
    ScrollableContent,
    ModalHeader,
} from "../Styles/InputStyles"
import { toast } from "react-toastify"
import { MdClose } from "react-icons/md"
import tw from "tailwind-styled-components"
import moment from "moment"
import "react-datepicker/dist/react-datepicker.css";
import DropZone from "../Notice/Dropzone"
import DateModal from "./DateModal"
import CategoryCard from "../CategoryCard"
import SelectCategoryModal from "./SelectCategoryModal"
import PaidUserModal from "./PaidUserModal"
import PaidToUserModal from "./PaidToUserModal"
import SinglePropSelectModal from "../SinglePropSelectModal"
import { natureExpensesModes, paymentModes } from "../../helpers"
import Config from "../../Config"
import SingleFlatSelectModal from "../SingleFlatSelectModal"

const EditExpenses = ({
    handleClose,
    selectedData,
    editExpenseMutate,
    editExpenseLoading,
    expenseData,
    categories,
    property
}) => {
    const formikRef = useRef(null);
    const [showDateRepetitionModal, setShowDateRepetitionModal] = useState(false)
    const [showCategoryModal, setShowCategoryModal] = useState(false)
    const [showPaidByModal, setShowPaidByModal] = useState(false)
    const [showPaidToModal, setShowPaidToModal] = useState(false)
    const [showPropertyModal, setShowPropertyModal] = useState(false)
    const [userValues, setUserValues] = useState({
        amount: selectedData?.amount || "",
        paymentDate: selectedData?.paidDate ? moment(selectedData.paidDate).format("YYYY-MM-DD") : "",
        repetition: selectedData?.repetitionType || "",
        description: selectedData?.description || "",
        paymentMode: selectedData?.paymentMethod || "",
        file: selectedData?.supportDoc || null,
        natureOfExpenses: selectedData?.expenseNature || 1,
        expenseTitle: selectedData?.expenseTitle || '',
    });

    const [selectedPaidBy, setSelectedPaidBy] = useState(null);
    const [selectedPaidTo, setSelectedPaidTo] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [isInitialized, setIsInitialized] = useState(false);
    const [height, setHeight] = useState(window.innerHeight);
    const [showFlatModal, setShowFlatModal] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (selectedData && property) {
            const paidByUser = expenseData?.users?.find((user) => user.id == selectedData.paidBy)
            const paidToVendor = expenseData?.vendors?.find((vendor) => vendor.id == selectedData.paidTo)
            let categoryOption = null
            categories?.forEach((categoryGroup) => {
                const match = categoryGroup.items.find((item) => item.value == selectedData.type)
                if (match) categoryOption = match
            })

            setSelectedPaidBy(paidByUser || null)
            setSelectedPaidTo(paidToVendor || null)
            setSelectedCategory(categoryOption || null)

            if (!isInitialized) {
                setUserValues({
                    amount: selectedData?.amount || "",
                    paymentDate: selectedData?.paidDate ? moment(selectedData.paidDate).format("YYYY-MM-DD") : "",
                    repetition: selectedData?.repetitionType || "",
                    description: selectedData?.description || "",
                    paymentMode: selectedData?.paymentMethod || "",
                    file: selectedData?.supportDoc || null,
                    natureOfExpenses: selectedData?.expenseNature || 1,
                    expenseTitle: selectedData?.expenseTitle || '',
                })
                setIsInitialized(true)
            }
        }
    }, [selectedData, expenseData, categories, isInitialized, property])

    const handleFormChange = (e) => {
        if (e && e.target) {
            const { name, value } = e.target
            if (name && (name === "amount" || name === "paymentDate" || name === "description")) {
                setUserValues((prev) => ({
                    ...prev,
                    [name]: value,
                }))
            }
        }
    }

    const getPropertyById = (propertyId) => {
        if (!propertyId) return null;
        return property.find(prop => prop.id === propertyId) || null;
    };

    const getFlatById = (propertyId, flatId) => {
        if (!propertyId || !flatId) return null;
        const prop = getPropertyById(propertyId);
        if (!prop || !prop.flats) return null;
        return prop.flats.find(flat => flat.id === flatId) || null;
    };

    const shouldShowFlatSelector = (propertyId) => {
        if (!propertyId) return false;
        const prop = getPropertyById(propertyId);
        return prop?.type === Config.PROPERTY_TYPE.FLAT && prop?.flats?.length > 0;
    };

    const getFlatsForSelectedProperty = (propertyId) => {
        if (!propertyId) return [];
        const prop = getPropertyById(propertyId);
        return prop?.flats || [];
    };

    const handleSelectedPaidBy = (selectedOption) => {
        setSelectedPaidBy(selectedOption)
        if (formikRef.current) {
            formikRef.current.setFieldValue("paidBy", selectedOption.id)
            formikRef.current.setFieldValue("paidByUserType", selectedOption.userType)
        }
    }

    const handleSelectedPaidTo = (selectedOption) => {
        setSelectedPaidTo(selectedOption)
        if (formikRef.current) {
            formikRef.current.setFieldValue("paidTo", selectedOption.id)
            formikRef.current.setFieldValue("paidToUserType", selectedOption.userType)
        }
    }

    const handleSelectedCategory = (selectedOption) => {
        setSelectedCategory(selectedOption)
        if (formikRef.current) {
            formikRef.current.setFieldValue("category", selectedOption.value)
        }
    }

    const handleSelectedProperty = (selectedOption) => {
        if (formikRef.current) {
            formikRef.current.setFieldValue("property", selectedOption?.id || "")
            formikRef.current.setFieldValue("flat", "")
        }
    }

    const handleSelectedFlat = (selectedOption) => {
        if (formikRef.current) {
            formikRef.current.setFieldValue("flat", selectedOption?.id || "")
        }
    }

    const renderSelectedFlat = (flatId, propertyId) => {
        if (!flatId || !propertyId) return "Select Flat";
        const flat = getFlatById(propertyId, flatId);
        if (!flat || !flat.name) return "Select Flat";
        return `Flat ${flat.name}`;
    };

    const renderSelectedProperty = (propertyId) => {
        if (!propertyId) return "Select Property";
        const prop = getPropertyById(propertyId);
        if (!prop) return "Select Property";
        return prop.name;
    };

    const handlePaymentModeChange = (value) => {
        setUserValues((prev) => ({
            ...prev,
            paymentMode: value,
        }))
        if (formikRef.current) {
            formikRef.current.setFieldValue("paymentMode", value)
        }
    }

    const handleNatureModeChange = (value) => {
        setUserValues((prev) => ({
            ...prev,
            natureOfExpenses: value,
        }))
        if (formikRef.current) {
            formikRef.current.setFieldValue("natureOfExpenses", value)
        }
    }

    const handleSubmit = (values) => {
        const amountRegex = /^(?!0+$)\d{1,8}$/
        const maxAmount = 10000000;

        if (!amountRegex.test(values.amount) || Number.parseInt(values.amount) > maxAmount) {
            toast.error("Monthly rent must be between 1 and 1,00,00,000 and contain only numbers")
            return
        }

        if (!values.category) {
            toast.error("Category is required")
            return
        }
        if (!values.repetition) {
            toast.error("Repetition is required")
            return
        }
        if (!values.paymentDate) {
            toast.error("Payment date is required")
            return
        }
        if (!values.paidBy) {
            toast.error("Paid by is required")
            return
        }
        if (!values.paidTo) {
            toast.error("Paid to is required")
            return
        }
        if (!values.paymentMode) {
            toast.error("Payment mode is required")
            return
        }
        if (!values.natureOfExpenses) {
            toast.error("Nature of expenses is required")
            return
        }

        const formData = new FormData();
        formData.append("amount", Number(values.amount));
        formData.append("type", Number(values.category));
        formData.append("expenseTitle", values?.expenseTitle || '');
        formData.append("repetitionType", Number(values.repetition));
        formData.append("description", values.description);
        formData.append("paidDate", moment(values.paymentDate).format("YYYY-MM-DD"));
        formData.append("paidBy", Number(values.paidBy));
        formData.append("paidTo", Number(values.paidTo));
        formData.append("paymentMode", values.paymentMode);
        formData.append("propertyId", Number(values.property));
        formData.append("paidByUserType", Number(selectedPaidBy?.userType));
        formData.append("paidToUserType", Number(selectedPaidTo?.userType));
        formData.append("expenseId", Number(selectedData.id));
        formData.append("expenseNature", values.natureOfExpenses)

        if (values.file) {
            formData.append("file", values.file[0])
        }
        if (values.flat) {
            formData.append("flatId", Number(values.flat));
        }

        editExpenseMutate(formData);
    }

    const handleDateRepetitionSave = (date) => {
        if (formikRef.current) {
            formikRef.current.setFieldValue("paymentDate", date)
        }
    }

    return (
        <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">Edit Expense</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>

            <div className="px-6 h-full flex flex-col justify-between">
                <Formik
                    innerRef={formikRef}
                    initialValues={{
                        amount: userValues.amount,
                        category: selectedCategory?.value || "",
                        expenseTitle: userValues?.expenseTitle || "",
                        repetition: userValues.repetition,
                        paymentDate: userValues.paymentDate,
                        property: selectedData?.propertyList[0]?.id || "",
                        flat: selectedData?.flatList?.[0]?.id || "",
                        paidBy: selectedPaidBy?.id || "",
                        paidTo: selectedPaidTo?.id || "",
                        paymentMode: userValues.paymentMode,
                        natureOfExpenses: userValues.natureOfExpenses,
                        description: userValues.description,
                        expenseId: selectedData?.id,
                        file: selectedData?.supportDoc,
                    }}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {({ values, setFieldValue, handleChange }) => (
                        <Form onChange={handleFormChange}>
                            <ScrollableContent className="max-h-[calc(100vh-140px)]">
                                <Wrapper>
                                    <InputGroup>
                                        <Label htmlFor="category">Category *</Label>
                                        <CategoryCard
                                            title="Category"
                                            selectedCategory={selectedCategory}
                                            onClick={() => setShowCategoryModal(true)}
                                        />
                                    </InputGroup>
                                    {selectedCategory?.label === 'Others' && (
                                        <InputGroup>
                                            <Label htmlFor="expenseTitle">Expense Title *</Label>
                                            <FieldWrappers>
                                                <Field
                                                    type="text"
                                                    id="expenseTitle"
                                                    name="expenseTitle"
                                                    value={userValues.expenseTitle}
                                                    onChange={(e) => {
                                                        setUserValues(prev => ({
                                                            ...prev,
                                                            expenseTitle: e.target.value,
                                                        }));
                                                        setFieldValue("expenseTitle", e.target.value);
                                                    }}
                                                    autoComplete="off"
                                                    placeholder="Enter expense title"
                                                    className="w-full"
                                                    maxLength={30}
                                                />
                                            </FieldWrappers>
                                        </InputGroup>
                                    )}
                                    <CombineInputGroup>
                                        <InputGroup>
                                            <Label htmlFor="amount">Amount *</Label>
                                            <FieldWrappers>
                                                <Field
                                                    type="text"
                                                    name="amount"
                                                    id="amount"
                                                    className={`w-full truncate`}
                                                    value={userValues.amount}
                                                    maxLength={10}
                                                    onChange={(e) => {
                                                        handleChange(e)
                                                        setUserValues((prev) => ({
                                                            ...prev,
                                                            amount: e.target.value,
                                                        }))
                                                        setFieldValue("amount", e.target.value)
                                                    }}
                                                />
                                            </FieldWrappers>
                                        </InputGroup>
                                    </CombineInputGroup>

                                    <InputGroup>
                                        <Label htmlFor="paidBy">Paid by *</Label>
                                        <CategoryCard
                                            title="Paid By"
                                            selectedCategory={selectedPaidBy}
                                            onClick={() => setShowPaidByModal(true)}
                                        />
                                    </InputGroup>

                                    <InputGroup>
                                        <Label htmlFor="paidTo">Paid to *</Label>
                                        <CategoryCard
                                            title="Paid to"
                                            selectedCategory={selectedPaidTo}
                                            onClick={() => setShowPaidToModal(true)}
                                        />
                                    </InputGroup>

                                    <InputGroup>
                                        <Label>Select property </Label>
                                        <CategoryCard
                                            title="Property"
                                            selectedCategory={values.property ? {
                                                name: renderSelectedProperty(values.property),
                                                value: values.property
                                            } : null}
                                            onClick={() => setShowPropertyModal(true)}
                                        />
                                    </InputGroup>

                                    {shouldShowFlatSelector(values.property) && (
                                        <InputGroup>
                                            <Label>Select Flat (optional)</Label>
                                            <CategoryCard
                                                title="Flat"
                                                selectedCategory={values.flat ? {
                                                    name: renderSelectedFlat(values.flat, values.property),
                                                    value: values.flat
                                                } : null}
                                                onClick={() => setShowFlatModal(true)}
                                            />
                                        </InputGroup>
                                    )}

                                    <InputGroup>
                                        <Label>Payment Mode *</Label>
                                        <PaymentModeWrapper>
                                            {paymentModes.map((mode) => (
                                                <PaymentModeCard
                                                    key={mode.value}
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        setFieldValue("paymentMode", mode.value)
                                                        handlePaymentModeChange(mode.value)
                                                    }}
                                                    className={`${userValues.paymentMode === mode.value ? "bg-blue-200" : "bg-gray-100"
                                                        } `}
                                                >
                                                    <span className="text-sm">{mode.label}</span>
                                                </PaymentModeCard>
                                            ))}
                                        </PaymentModeWrapper>
                                    </InputGroup>

                                    <InputGroup>
                                        <Label htmlFor="description">Description </Label>
                                        <Field
                                            as={Textarea}
                                            id="description"
                                            name="description"
                                            rows={5}
                                            placeholder="Enter Description"
                                            value={userValues.description}
                                            onChange={(e) => {
                                                handleChange(e)
                                                setUserValues((prev) => ({
                                                    ...prev,
                                                    description: e.target.value,
                                                }))
                                                setFieldValue("description", e.target.value)
                                            }}
                                        />
                                    </InputGroup>
                                    <InputGroup>
                                        <Label>Nature of Expenses *</Label>
                                        <NatureModeWrapper>
                                            {natureExpensesModes.map((mode) => (
                                                <PaymentModeCard
                                                    key={mode.value}
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        setFieldValue("natureOfExpenses", mode.value)
                                                        handleNatureModeChange(mode.value)
                                                    }}
                                                    className={`${userValues.natureOfExpenses === mode.value ? "bg-blue-200" : "bg-gray-100"
                                                        } `}
                                                >
                                                    <span className="text-sm">{mode.label}</span>
                                                </PaymentModeCard>
                                            ))}
                                        </NatureModeWrapper>
                                    </InputGroup>
                                    <InputGroup>
                                        <Label htmlFor="file">
                                            Document(optional)
                                        </Label>
                                        <FieldWrapper $select={true}>
                                            <Field
                                                required
                                                name="file"
                                                type="text"
                                                id="file"
                                                autoComplete="off"
                                            >
                                                {(props) => (
                                                    <DropZone
                                                        fields={props.field}
                                                        setFieldValue={props.form.setFieldValue}
                                                        componentFor="expense"
                                                        acceptedFiles="image/*,application/pdf"
                                                        File={props.field.value ? [props.field.value] : null}
                                                    />
                                                )}
                                            </Field>
                                        </FieldWrapper>
                                    </InputGroup>
                                </Wrapper>
                            </ScrollableContent>
                            <ActionSection>
                                <ExpenseDateRepetitionBtn type="button" onClick={() => setShowDateRepetitionModal(true)}>
                                    Expense Date / Repetition
                                    <div className="text-sm text-gray-800 mt-1">
                                        {values.paymentDate
                                            ? moment(values.paymentDate).format("YYYY-MM-DD")
                                            : ""}
                                        {" / "}
                                        {values.repetition === 1
                                            ? "One Time"
                                            : values.repetition === 2
                                                ? "Monthly"
                                                : ""}
                                    </div>
                                </ExpenseDateRepetitionBtn>
                                <SubmitBtn type="submit" disabled={editExpenseLoading}>
                                    {editExpenseLoading ? "Updating ..." : "Update"}
                                </SubmitBtn>
                            </ActionSection>

                            <DateModal
                                isOpen={showDateRepetitionModal}
                                onClose={() => setShowDateRepetitionModal(false)}
                                onSave={handleDateRepetitionSave}
                                initialDate={values.paymentDate}
                            />

                            <SelectCategoryModal
                                isOpen={showCategoryModal}
                                onClose={() => setShowCategoryModal(false)}
                                onSelect={handleSelectedCategory}
                                categories={categories}
                                selectedCategory={selectedCategory}
                            />

                            <PaidUserModal
                                isOpen={showPaidByModal}
                                onClose={() => setShowPaidByModal(false)}
                                onSelect={handleSelectedPaidBy}
                                options={expenseData?.users}
                                selectedPaidBy={selectedPaidBy}
                            />

                            <PaidToUserModal
                                isOpen={showPaidToModal}
                                onClose={() => setShowPaidToModal(false)}
                                onSelect={handleSelectedPaidTo}
                                options={expenseData?.vendors}
                                landlordList={expenseData?.landlords}
                                selectedPaidTo={selectedPaidTo}
                                title="Select Paid To"
                            />

                            <SinglePropSelectModal
                                isOpen={showPropertyModal}
                                onClose={() => setShowPropertyModal(false)}
                                onSelect={handleSelectedProperty}
                                options={property}
                                selectedProperty={getPropertyById(values.property)}
                            />

                            <SingleFlatSelectModal
                                isOpen={showFlatModal}
                                onClose={() => setShowFlatModal(false)}
                                onSelect={handleSelectedFlat}
                                options={getFlatsForSelectedProperty(values.property)}
                                selectedFlat={getFlatById(values.property, values.flat)}
                                title="Select Flat"
                            />
                        </Form>
                    )}
                </Formik>
            </div>
        </Container>
    )
}

const FieldWrapper = tw.div`w-full`;
const Container = tw.div`bg-white w-full h-full flex flex-col relative`
const Header = tw.div`flex items-center justify-between bg-[#0078BD] py-4 px-4`
const Textarea = tw.textarea`min-h-10 max-h-40 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600  focus:border-sky-600 focus:outline-none duration-200 w-full h-20 resize-y  break-words overflow-hidden`
const PaymentModeWrapper = tw.div`grid grid-cols-4 gap-2 my-1.5`
const NatureModeWrapper = tw.div`grid grid-cols-2 gap-2 my-1.5`
const PaymentModeCard = tw.button`flex flex-col items-center justify-center p-2 border rounded-lg shadow-sm cursor-pointer`
const ExpenseDateRepetitionBtn = tw.button`
  flex items-center justify-center flex-col
  px-4 py-2
  text-sm font-medium text-gray-600
  bg-white 
  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
  disabled:opacity-50
`

export default EditExpenses